import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Button, Typography, Stack, } from '@mui/material';
import moment from 'moment';
import { getData } from '../../../../services/library';
import { UrlApi } from '../../../../services/apirest';
import { DownloadFiles, ViewUploadFile } from '../../../../services/DownloadFiles';
import { AdjuntoFileCard } from '../../../Form/AdjuntoField';
import { formatoImporte } from '../../formatoImporte';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Drawer from '@mui/material/Drawer';
import Container from "@mui/material/Container";
import ModalVerReq from '../../ModalVerReq';
import { ViewList } from '@mui/icons-material';
import { Visibility } from '@material-ui/icons';

function DatosOrden(props) {
  const [listaMateriales, setlistaMateriales] = useState(null);
  const [datosReq, setDatosReq] = useState(null)
  const [datos, setDatos] = useState(props.datos);
  const [circular, setCircular] = useState(false);
  const [presupuestos, setPresupuestos] = useState([]);
  const [openDialogReq, setOpenDialogReq] = useState(false);
  const [dataDialog, setdataDialog] = useState({})
  const tipoMonedaMapping = {
    82: "u$s",
    83: "$",
    84: "€",
  };

  const tipoMoneda = datos.tipo_moneda;
  const iconoMoneda = tipoMonedaMapping[tipoMoneda] || "Error";

  const obtenerListaMateriales = async () => {
    getData('/lista_materiales/ordencompra/' + datos.uuid_ordencompra, setlistaMateriales)
    setCircular(true);
    setTimeout(() => {
      setCircular(false);
    }, 500);
  };

  useEffect(() => {
    obtenerListaMateriales();
  }, []);

  useEffect(() => {
    getData('/requerimientos_materiales/ordencompra/' + datos.uuid_ordencompra, setDatosReq)
  }, [datos.uuid_ordencompra]);

  useEffect(() => {
    const fileId = datos.origen === "requerimiento"
      ? datosReq?.[0]?.uuid_requerimiento
      : datos.uuid_ordencompra;
    if (!fileId) return;

    let cancelled = false;
    fetch(UrlApi + "/uploadfiles/todownload/" + fileId)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled) setPresupuestos(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setPresupuestos([]);
      });

    return () => {
      cancelled = true;
    };
  }, [datos.origen, datos.uuid_ordencompra, datosReq]);

  const style = {
    backgroundColor: "#ffffff",
    width: "100%"
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#92a898",
      color: theme.palette.common.white,
      fontSize: 14,
      padding: 5
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: 5,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: "white",
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const handleOpenDialog = (datos) => {
    setOpenDialogReq(true)
    setdataDialog(datos)
  };

  return (
    <>
      <Drawer open={props.anchor} onClose={() => props.anchor(false)} anchor="right">
        <Container maxWidth="xl">
          <Box
            key={datos.idordencompra}
            width="100%"
            role="presentation" onClick={() => props.anchor(false)}
            backgroundColor="#CCD1D1"
            alignItems="center"
            justifyContent="center"
            mt={7}>
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              textAlign="center"
            >
              Visualización de orden de compra N° {datos.idordencompra}
            </Typography>
          </Box>

          <Box
            backgroundColor="#F4F6F6"
            p={2}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}>

            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.nombre_fantasia ?? datos.razon_social}
                  style={style}
                  label="Proveedor"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.condicion}
                  style={style}
                  label="Condicion de pago"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.iva_incluido === 1 ? "Incluido" : "No incluido"}
                  style={style}
                  label="Iva"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.pago_anticipado === 1 ? "Anticipado" : "No anticipado"}
                  style={style}
                  label="Pago"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>
            </Grid>

            {!circular && datos.origen === "manual" ? (
              <>
                <Grid container spacing={0.5} mt={1} alignItems="center" justifyContent="space-between">
                  <Grid item xs={3}>
                    <TextField
                      focused
                      color="primary"
                      size="small"
                      value={datos.nombre_sucursal}
                      style={style}
                      label="Sucursal"
                      InputProps={{
                        readOnly: true,
                      }} />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      focused
                      color="primary"
                      size="small"
                      value={datos.patente !== null ? datos.patente : "No hay registro"}
                      style={style}
                      label="Patente"
                      InputProps={{
                        readOnly: true,
                      }} />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      focused
                      color="primary"
                      size="small"
                      value={moment(datos.fecha_entrega).format("DD-MM-YYYY")}
                      style={style}
                      label="Fecha de entrega"
                      InputProps={{
                        readOnly: true,
                      }} />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      focused
                      color="primary"
                      size="small"
                      value={datos.usuario_crea ? `${datos.nombrepila + " " + datos.apellido}` : "No hay registro"}
                      style={style}
                      label="Usuario"
                      InputProps={{
                        readOnly: true,
                      }} />
                  </Grid>
                </Grid>

              </>
            ) : null}

            {!circular && datos.origen === "requerimiento" ? (
              <>
                {datosReq && datosReq.map((req, index) => (
                  <React.Fragment key={index}>
                    <Grid container spacing={1} mt={0.5} alignItems="center" justifyContent="space-between">
                      <Grid item xs={1.5}>
                        {/* <TextField
                          focused
                          fullWidth
                          color="primary"
                          size="small"
                          label="Nro requerimiento"
                          value={req.idrequerimiento}
                          style={style}
                          InputProps={{ readOnly: true }}
                          onClick={()=>console.log("puedo hacer click")}
                        /> */}
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => handleOpenDialog(req)}
                          size="medium"
                        >
                          <Visibility sx={{ fontSize: 18 }} /> Req: {req.idrequerimiento}
                        </Button>
                      </Grid>

                      <Grid item xs={3}>
                        <TextField
                          focused
                          color="primary"
                          size="small"
                          fullWidth
                          label="Sucursal"
                          value={req.nombre_sucursal ?? "No hay registro"}
                          style={style}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <TextField
                          focused
                          color="primary"
                          fullWidth
                          size="small"
                          label="Patente"
                          value={req.patente ?? "No hay registro"}
                          style={style}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <TextField
                          focused
                          color="primary"
                          fullWidth
                          size="small"
                          label="Fecha de entrega"
                          value={moment(datos.fecha_entrega).format("DD-MM-YYYY")}
                          style={style}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <TextField
                          focused
                          color="primary"
                          fullWidth
                          size="small"
                          label="Usuario"
                          value={
                            req.usuario_registra
                              ? `${req.nombrepila ?? ""} ${req.apellido ?? ""}`.trim()
                              : "No hay registro"
                          }
                          style={style}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ))}

              </>
            ) : null}
          </Box>

          <Box sx={{ width: '100%' }}>
            <TableContainer component={Paper}>
              <Table sx={{ mt: 1 }} aria-label="Tabla de materiales y costos">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">Cantidad</StyledTableCell>
                    <StyledTableCell align="left">Unidad</StyledTableCell>
                    <StyledTableCell align="left">Articulo/Servicio</StyledTableCell>
                    <StyledTableCell align="left">Precio unitario</StyledTableCell>
                    <StyledTableCell align="left">Bonificación</StyledTableCell>
                    <StyledTableCell align="left">Subtotal</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listaMateriales?.length ? (
                    listaMateriales.map((lista) => (
                      <StyledTableRow key={lista.idlista}>
                        <StyledTableCell align="left">{lista.total_cantidad_actualizada}</StyledTableCell>
                        <StyledTableCell align="left">{lista.descripcion ?? lista.descripcion_material}</StyledTableCell>
                        <StyledTableCell align="left">{lista.nombre ?? lista.material}</StyledTableCell>
                        <StyledTableCell align="center">
                          {iconoMoneda}
                          {formatoImporte(lista.precio_unitario)}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {lista.bonificacion_pesos !== null
                            ? `$${formatoImporte(lista.bonificacion_pesos)}`
                            : lista.bonificacion_porcentaje !== null
                              ? `${lista.bonificacion_porcentaje}%`
                              : '-'}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {iconoMoneda}
                          {formatoImporte(lista.subtotal)}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No hay materiales disponibles
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell align="left">Bonificación al precio total</TableCell>
                    <TableCell colSpan={4} />
                    <TableCell align="right">
                      {datos.bonificacion_pesos !== null
                        ? `$${formatoImporte(datos.bonificacion_pesos)}`
                        : datos.bonificacion_porcentaje !== null
                          ? `${datos.bonificacion_porcentaje}%`
                          : '-'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">Total</TableCell>
                    <TableCell colSpan={4} />
                    <TableCell align="right">
                      {iconoMoneda}
                      {formatoImporte(datos.total)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {datos.comentarios_internos ? (
            <Box>
              <TextField
                focused
                margin="dense"
                variant="filled"
                size="small"
                value={datos.comentarios_internos ? datos.comentarios_internos : "No hay comentarios cargados."}
                style={style}
                multiline

                label="Comentarios internos"
                InputProps={{
                  readOnly: true,
                }} />
            </Box>
          ) : null}

          {datosReq && datosReq.observaciones ? (
            <Box>
              <TextField
                focused
                margin="dense"
                variant="filled"
                size="small"
                value={datosReq.observaciones ? datosReq.observacioness : "No hay observaciones cargadas."}
                style={style}
                multiline
                label="Observaciones"
                InputProps={{
                  readOnly: true,
                }} />
            </Box>
          ) : null}

          {props.datos && datos.observacion_baja ? (
            <Box>
              <TextField
                focused
                margin="dense"
                variant="filled"
                size="small"
                color="error"
                value={datos.observacion_baja}
                style={style}
                multiline
                label="Observaciones"
                InputProps={{
                  readOnly: true,
                }} />
            </Box>
          ) : null}

          <Grid item xs={12} sm={6} md={4} sx={{ mt: 1 }}>
            {presupuestos.length > 0 ? (
              <Stack spacing={1}>
                {presupuestos.map((archivo) => (
                  <AdjuntoFileCard
                    key={archivo.id}
                    title="Presupuesto"
                    idTipoAdjunto={archivo.id}
                    hasFile
                    fileName={archivo.nombre}
                    disabled
                    showRemoveAction={false}
                    showDownloadAction
                    showViewAction
                    onFileChange={() => {}}
                    onView={() =>
                      ViewUploadFile(
                        `${archivo.id_archivo}-${archivo.nombre}`,
                        archivo.extension
                      )
                    }
                    onDownload={() =>
                      DownloadFiles(`${archivo.id_archivo}-${archivo.nombre}`)
                    }
                  />
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Sin presupuesto cargado
              </Typography>
            )}
          </Grid>

          {openDialogReq ?
            <ModalVerReq
              datos={dataDialog}
              open={setOpenDialogReq}
            /> : null}

        </Container>
      </Drawer>

      <br />
      <br />
    </>
  )

}

export default DatosOrden
